import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { AppUserRepository }      from 'Domain/Repositories';
import { message }              from 'antd';

export const deleteAppUserEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.deleteAppUserRequest.type),
    mergeMap(action => from(AppUserRepository.remove(action.payload.id))
      .pipe(
        mergeMap(() => {
          message.success('AppUser wurde erfolgreich gelöscht.');
          return from([
            Actions.deleteAppUserSuccess({ id: action.payload.id }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.deleteAppUserFailure(error),
          ]);
        })
      )
    ),
  );
};
